<template>
  <div class="registerBox" style="background-image: url('static/image/register_bg.png');">
    <div class="register_info">
      <div class="register_txt1">
        进一步了解针对您企业的最佳解决方案
      </div>
      <div class="register_txt2">
        服务热线：4000-119-329
      </div>
      <div class="inputBox1">
        <el-input
          style="width: 300px;margin-right: 20px"
          placeholder="姓名（必填）"
          v-model="user_name">
          <i slot="prefix" class="el-input__icon el-icon-user-solid"></i>
        </el-input>
        <el-input
          style="width: 300px"
          placeholder="手机（必填）"
          v-model="user_phone">
          <i slot="prefix" class="el-input__icon el-icon-mobile-phone"></i>
        </el-input>
      </div>
      <div class="inputBox2">
        <el-input
          style="width: 300px;margin-right: 20px;"
          placeholder="公司（必填）"
          v-model="user_address">
          <i slot="prefix" class="el-input__icon el-icon-office-building"></i>
        </el-input>
        <el-input
          style="width: 300px"
          placeholder="邮箱（必填）"
          v-model="user_email">
          <i slot="prefix" class="el-input__icon el-icon-message"></i>
        </el-input>
      </div>
      <div class="register_btn">
        立即申请
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "registerCom",
      data(){
          return{
            user_name:"",
            user_phone:"",
            user_address:"",
            user_email:"",
          }
      }
    }
</script>

<style scoped>
  .registerBox{
    width: 100%;
    height:480px;
    box-sizing: border-box;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
  }
  .register_info{
    width: 1200px;
    box-sizing: border-box;
    padding: 80px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .register_txt1{
    font-size:28px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(40,52,87,1);
    line-height:30px;
  }
  .register_txt2{
    font-size:24px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
    box-sizing: border-box;
    padding: 35px 0;
  }
  .inputBox1{
    box-sizing: border-box;
    padding: 20px 0;
  }
  .inputBox2{
    box-sizing: border-box;
    padding:0 0 20px 0;
  }
  .register_btn{
    width:620px;
    height:44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background:linear-gradient(90deg,rgba(42,98,255,1),rgba(44,163,255,1));
  }
</style>



// WEBPACK FOOTER //
// src/components/common/registerCom.vue